import loader from "../../assets/icons/loader.gif";
import styles from "./ui.module.scss";

export const Loader = () => {
  return (
    <div className={styles.loader}>
      <img src={loader} alt="loader..." loading="lazy"/>
    </div>
  );
};
